import { FilterType } from '../Enums/FilterType';

export class FilterItem {
  
    /** jQuery selector used to retrieve the parameter value*/

    jQuerySelector: string
     /** FormControlName used to retrieve the  value Of Control*/
     FormControlName: string;
    /**  The action parameter exact name (case sensitive)*/
    ActionParameterName: string
    /** Check If This Filter Is Form Control Or js Filter  */
    IsFormControl: boolean=true
     /**Set Filter Type To Filter*/
     FilterType:FilterType

}
